import React, { useEffect, useMemo, useRef, useState } from "react";
import { Divider } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Button,
  ButtonGroup,
  FormControl,
  MenuItem,
  Select,
  Box,
  Typography,
  IconButton,
  Tab,
  Tooltip,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  GetUserId,
  getAttributes,
  getUserDetails,
  GetUserInfo,
} from "../../../../_utilities/getUserInfo";
import * as _ser1 from "../../../../_redux/_services/ApplicantsSlice";
import * as _serapplicant from "../../../../_redux/_services/ApplicantsSlice";
import * as _sercloud from "../../../../_redux/_services/CloudSourcingSlice";
import * as _ser from "../../../../_redux/_services/JobPostingSlice";
import { customFieldsAsync } from "../../../../_redux/_services/UserManagerSlice";
import { defaultApplicantsData } from "../../../../_utilities/defaultfieldsModel";
import {
  getCandidateInternalStatus,
  getCandidateStatusId,
  getCandidateStatusCustomValues,
} from "../../../../_utilities/internalexternalhelper";
import AssociateCards from "../../../../components/AssociateCards/AssociateCards";
import CkEditor from "../../../../components/CkEditor/CkEditor";
import GenerateTemplateNew from "../../../../components/GenerateTemplate/GenerateTemplateNew";
import RightSideBar from "../../../../components/Rightsidebar/RightSideBar";
import ApplicantsManualUploadPopup from "../../../Applicants/ApplicantsTable/ApplicantsManualUploadPopup";
import { ApplicantsRenderData } from "../../../Applicants/ApplicantsTable/ApplicantsRenderData";
import DuplicateApplicantsManualUploadPopup from "../../../Applicants/ApplicantsTable/DuplicateApplicantsManualUploadPopup";
import Loader from "../../../../components/Loader/Loader";
import { updateGlobalLoading } from "../../../../_redux/LoaderSlice";
import "./JobpostingAssociatedApplicants.css";
import { updateSnackbar } from "../../../../_redux/SnackbarSlice";
import { UpdateStausillus } from "../../../../Icons/UpdateStausillus";
import { Notescall } from "../../../../Icons/Notescall";
import { Notesemail } from "../../../../Icons/Notesemail";
import { ViewFileIcon } from "../../../../Icons/ViewFileIcon";
import { DownloadIcon } from "../../../../Icons/DownloadIcon";
import * as _userSer from "../../../../_redux/_services/UserManagerSlice";
import { GetTimeZone } from "../../../../_utilities/GetTimeZone";
import axios from "axios";
import DocumentViewer from "../../../../components/DocumentViewer/DocumentViewer";
import Searchbar from "../../../../components/Searchbar/Searchbar";
import Pagination from "../../../../components/DynamicTable/Pagination";
import Cookies from "js-cookie";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import WarningPopup from "../../../../components/WarningPopup/WarningPopup";
import { warningPopups } from "../../../../constants/constants";
import FloatingMenu from "../../../../components/FloatingMenu/FloatingMenu";
import {
  AssociateAppliantMenuOptions,
  AssociateAppliantPendingMenuOptions,
} from "../../../../constants/floatingMenuConstants";
import { getFileExtension, safeJsonParse } from "../../../../_utilities/utilities";
import EmailDeliverySummary from "../../../../components/EmailDeliverySummary";
import ApplicantCardNew from "../../../../components/ApplicantCardNew/ApplicantCardNew";
import { ReloadIcon } from "../../../../Icons/ReloadIcon";
import UpdateResumePopup from "./UpdateResumePopup";
import * as _projectSer from "../../../../_redux/_services/ProjectsSlice";
import { PublicView } from "../../../../Icons/publicView";
import { PersionView } from "../../../../Icons/persionView";
// import { Tabs } from "material-ui";

const initalState = { data: null, message: "", isloader: true };

const getApplicantPath = () =>
  Cookies.get("applicantViewPreference") || "/ats/layout/applicants/landing";

const JobpostingAssociatedApplicants = ({
  data,
  selectedJobId,
  selectedJobCode,
  onReceiveProps,
}) => {
  const [AssociatedApplicants, setAssociatedApplicants] = useState([]);
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [componentType, setComponentType] = useState("");
  const [questionsData, setQuestionsData] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [qnsCount, setQnsCount] = useState(0);
  const [candidateStatusValues, setCandidateStatusValues] = useState([]);
  const [portalAccociatedApplicants, setPortalAccociatedApplicants] = useState(
    [],
  );
  const [searchQuery, setSearchQuery] = useState("");
  const [config, setConfig] = useState(configuration);
  const [moduleType, setModuleType] = useState("Associated Applicants");
  const [actionType, setActionType] = useState("");
  const [selectedAction, setSelectedAction] = useState("");
  const [rejectedApplicants, setRejectedApplicants] = useState([]);
  const [profileData, setProfileData] = useState("");
  const [applicantTemp, setApplicantTemp] = useState("");
  const [applicantCodes, setApplicantCodes] = useState([]);
  const [docUrl, setDocUrl] = useState("");
  const [isGenerateTemplate, setIsGenerateTemplate] = useState(false);
  const [bulkUploadMessage, setBulkUploadMessage] = useState({});
  const [isBulkuploadResponse, setIsBulkuploadResponse] = useState(false);
  const [isBulkUpdateStatus, setIsBulkUpdateStatus] = useState(false);
  const [bulkUpdateStatusArray, setbulkUpdateStatusArray] = useState([]);
  const [isValidUser, setIsValidUser] = useState(false);
  const [isDocumentView, setIsDocumentView] = useState(false);
  const [previewType, setPreviewType] = useState("");
  const [selectedApplicants, setSelectedApplicants] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showNoData, setShowNoData] = useState(false);
  const [isAssociatedProfile, setIsAssociatedProfile] = useState(false);
  const [applicantDocumentsDetails, setApplicantDocumentsDetails] = useState(
    [],
  );
  const [pannelobj, setPannelobj] = useState({
    title: "",
    description: "",
    bgImage: "",
    navigateTo: "",
  });
  const [tooltipCardId, setTooltipCardId] = useState(null);
  const [showSelectAllTip, setShowSelectAllTip] = useState(
    sessionStorage.getItem("hasSeenSelectAllTip") !== "true",
  );

  const responseOfQuestionAnswer = useSelector(
    (state) => state.GetQuestionsAnswers.data,
  );
  const bulkUploadResumeData = useSelector(
    (store) => store.BulkUploadResume.data,
  );
  const customFieldsData = useSelector((state) => state.CustomFields.data);
  const sendEmail = useSelector((state) => state.SendEmail.data);
  const ClientBulkEmail = useSelector((state) => state.ClientBulkEmail.data);
  const showLoader = useSelector((state) => state.Loader.value);
  const AccociatedApplicantsDataCode = useSelector(
    (state) => state.GetAssociatedApplicants.code,
  );
  const AssociatedApplicantById = useSelector(
    (state) => state.GetAssociatedApplicantById.data,
  );
  const updateCandidateCode = useSelector(
    (state) => state.UpdateCandidateStatus.data,
  );
  const DeleteAssociatedJobseekercode = useSelector(
    (state) => state.DeleteAssociatedJobseeker.data,
  );
  const docData = useSelector((state) => state.Downloaddocument.data);
  const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";
  const dispatch = useDispatch();

  useEffect(() => {
    if (bulkUploadResumeData) {
      setIsBulkuploadResponse(true);
      setBulkUploadMessage(bulkUploadResumeData);
      dispatch(_ser1.bulkUploadResumeStartReducer(initalState));
      onReceiveProps("associateApplicant");
    }
  }, [bulkUploadResumeData]);

  useEffect(() => {
    async function init() {
      let userId = await GetUserId();
      dispatch(customFieldsAsync(userId));
    }
    init();
  }, []);

  useEffect(() => {
    if (customFieldsData && customFieldsData.length > 0) {
      const array = getCandidateStatusCustomValues(customFieldsData);
      setCandidateStatusValues(array);
    }
  }, [customFieldsData]);

  useEffect(() => {
    if (AccociatedApplicantsDataCode === 404) {
      setIsValidUser(true);
    }
  }, [AccociatedApplicantsDataCode]);

  useEffect(() => {
    if (!isGenerateTemplate) {
      if (!data?.length) {
        setAssociatedApplicants([]);
        setPortalAccociatedApplicants([]);
        setRejectedApplicants([]);
        return;
      }
      const qnsCount = data[0]?.qnscount || 0;
      setQnsCount(qnsCount);
      const associated = [];
      const pending = [];
      const rejected = [];
      data.forEach((e) => {
        const item = {
          ...e,
          isChecked: false,
          id: e.applicantID,
          percentage:
            e.matchPercentage !== -1
              ? Math.round(e.matchPercentage * 100)
              : "N/A",
          updatedDate: GetTimeZone(e.updatedDate),
          firstName: e.firstName || "",
          lastName: e.lastName || "",
          createdBy: `${e.firstName || ""} ${e.lastName || ""}`,
          screeningquestions:
            e.status?.toLowerCase() === "pending" || e.status === "Rejected"
              ? `${e.anscount}/${qnsCount}`
              : "",
        };
        if (candidateStatusValues.length) {
          item.status = getCandidateInternalStatus(
            item.status,
            candidateStatusValues,
          );
        }
        switch (item.status?.toLowerCase()) {
          case "pending":
            pending.push(item);
            break;
          case "rejected":
            rejected.push(item);
            break;
          default:
            associated.push(item);
        }
      });

      setAssociatedApplicants(associated);
      setPortalAccociatedApplicants(pending);
      setRejectedApplicants(rejected);
      dispatch(_ser.getAssociatedApplicantsStartReducer(initalState));
    }
  }, [data, candidateStatusValues, isGenerateTemplate]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedJobId, selectedJobCode]);

  const dataMap = {
    "Associated Applicants": AssociatedApplicants,
    "Pending Applicants": portalAccociatedApplicants,
    "Rejected Applicants": rejectedApplicants,
  };

  const currentList = filteredList || dataMap[moduleType] || [];

  const pageSize = 9;

  useEffect(() => {
    const totalPages = Math.ceil((currentList?.length || 0) / pageSize) || 1;
    if (currentPage > totalPages) {
      setCurrentPage(1);
    }
  }, [currentList, pageSize, currentPage]);

  useEffect(() => {
    let timer;
    if (currentList.length === 0 && !showLoader) {
      timer = setTimeout(() => {
        setShowNoData(true);
      }, 800);
    } else {
      setShowNoData(false);
    }
    return () => clearTimeout(timer);
  }, [currentList, showLoader, moduleType]);

  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return currentList.slice(start, start + pageSize);
  }, [currentList, currentPage]);

  const handleCheckboxChange = (item, isChecked) => {
    const updateList = (setList) => {
      setList((prev) =>
        prev.map((e) => (e.id === item.id ? { ...e, isChecked } : e)),
      );
    };

    if (moduleType === "Associated Applicants") {
      if (searchQuery && filteredList?.length > 0) {
        updateList(setFilteredList);
      } else {
        updateList(setAssociatedApplicants);
      }
    } else if (moduleType === "Pending Applicants") {
      if (searchQuery && filteredList?.length > 0) {
        updateList(setFilteredList);
      } else {
        updateList(setPortalAccociatedApplicants);
      }
    }
  };

  const handleSelectAll = (isChecked) => {
    const updatePaginatedList = (setList) => {
      setList((prev) => {
        const updated = [...prev];
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        for (let i = startIndex; i < endIndex && i < updated.length; i++) {
          updated[i] = {
            ...updated[i],
            isChecked,
          };
        }
        return updated;
      });
    };

    if (moduleType === "Associated Applicants") {
      if (searchQuery && filteredList?.length > 0) {
        updatePaginatedList(setFilteredList);
      } else {
        updatePaginatedList(setAssociatedApplicants);
      }
    } else if (moduleType === "Pending Applicants") {
      if (searchQuery && filteredList?.length > 0) {
        updatePaginatedList(setFilteredList);
      } else {
        updatePaginatedList(setPortalAccociatedApplicants);
      }
    }
    handleTooltipDismiss();
  };

  const handleTooltipDismiss = () => {
    setShowSelectAllTip(false);
    setTooltipCardId(null);
    sessionStorage.setItem("hasSeenSelectAllTip", "true");
  };


  const renderCards = () => {
    if (!paginatedData.length && showNoData) {
      return (
        <div className="detail-card-empty" style={{ width: "96%" }}>
          <img
            src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
            alt="No data"
          />
          No {moduleType.toLowerCase()}
        </div>
      );
    }
    return (
      <div className="detail-card-grid">
        {paginatedData.map((item, idx) => (
          <CardComponent
            key={item.id || idx}
            item={item}

            isFirst={currentPage === 1}
            onCardClickHandler={() => {
              dispatch(_ser.getAssociatedApplicantByIdAsync(item.asscoId));
            }}
            onCheckboxChange={() => {
              handleCheckboxChange(item, !item.isChecked);
            }}
            onDoubleClick={() => {
              handleSelectAll(!item.isChecked);
            }}
          />
        ))}
      </div>
    );
  };

  useEffect(() => {
    if(searchQuery === "" || filteredList.length === 0){
      const list = dataMap[moduleType] || [];
      setFilteredList(list);
    }
  }, [
    moduleType,
    AssociatedApplicants,
    portalAccociatedApplicants,
    rejectedApplicants,
  ]);

  const CardComponent = ({
    item,
    onCardClickHandler,
    onCheckboxChange,
    onDoubleClick,
    isFirst,
  }) => {
    const clickTimer = useRef(null);
    const handleClick = () => onCardClickHandler(item);
    return (
      <div className="detail-card">
        <div className="detail-card__header" onClick={handleClick}>
          <span className="detail-card__header-title">
            {item.applicantCode}
          </span>
        </div>
        {moduleType !== "Rejected Applicants" && (
          <div
            style={{
              display: "inline-flex",
              position: "absolute",
              right: "13px",
              top: "12px",
              gap: "8px",
            }}
          >
            {moduleType === "Associated Applicants" && (
              <div
                className="detail-card__badge"
                style={{ position: "initial" }}
                aria-label={item.percentage}
              >
                {item.percentage}
                {item.percentage === "N/A" ? "" : "%"}
              </div>
            )}

            <Tooltip
              slotProps={{
                popper: {
                  id: "select-all-tooltip",
                },
              }}
              placement="bottom-start"
              open={isFirst && tooltipCardId === item.id && showSelectAllTip}
              PopperProps={{
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [5, -20],
                    },
                  },
                ],
              }}
              title={
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                  }}
                >
                  <InfoOutlinedIcon sx={{ fontSize: 18, mt: "2px" }} />
                  <Typography
                    sx={{
                      fontSize: "14px",
                      lineHeight: 1.4,
                      flex: 1,
                    }}
                  >
                    <b style={{ color: '#fff' }}>Tip:</b> Double-click to select all applicants
                  </Typography>

                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleTooltipDismiss();
                    }}
                    sx={{
                      color: "#fff",
                      p: "2px",
                      mt: "-4px",
                    }}
                  >
                    <CloseIcon sx={{ fontSize: 16 }} />
                  </IconButton>
                </Box>
              }
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "#3f434a",
                    color: "#fff",
                    fontSize: "14px",
                    maxWidth: 260,
                    padding: "12px 14px",
                    borderRadius: "7px",
                    boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
                  },
                },
                arrow: {
                  sx: {
                    color: "#3f434a",
                  },
                },
              }}
            >

              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  if (clickTimer.current) {
                    clearTimeout(clickTimer.current);
                    clickTimer.current = null;
                    onDoubleClick();
                  } else {
                    clickTimer.current = setTimeout(() => {
                      onCheckboxChange();
                      clickTimer.current = null;
                    }, 250);
                  }
                }}
                onMouseEnter={() => {
                  if (!sessionStorage.getItem("hasSeenSelectAllTip") && tooltipCardId === null) {
                    setTooltipCardId(item.id);
                    sessionStorage.setItem("hasSeenSelectAllTip", "false");
                  }
                }}
              >
                {item?.isChecked ? (
                  <div>
                    <CheckBoxIcon sx={{ color: "var(--primary-bg-color)" }} />
                  </div>
                ) : (
                  <div className="newCardCheckbox">
                    <CheckBoxOutlineBlankIcon />
                  </div>
                )}
              </IconButton>
            </Tooltip>
          </div>
        )}
        <div onClick={handleClick}>
          <p>
            <b>{item.Applicantname}</b>
          </p>
          <p>
            <b>Contact No:</b> {item.ContactNumber}
          </p>
          <p>
            <b>Updated on:</b> {item.updatedDate}
          </p>
          {moduleType !== "Associated Applicants" ? (
            <p>
              <b>Sourced By:</b> {item.submittedByUser}
            </p>
          ) : (
            <p>
              <b>Recruiter:</b> {item.submittedByUser}
            </p>
          )}
          <p>
            Sourced from <b>{item.SourcedFrom}</b>
          </p>
        </div>
        <div>
          {moduleType !== "Associated Applicants" ? (
            <p>
              <b>Screening Questions:</b>{" "}
              <a
                style={{ textDecoration: "underline" }}
                onClick={(e) => {
                  e.stopPropagation();
                  showViewAnswer(item);
                }}
              >
                {item.screeningquestions}
              </a>
            </p>
          ) : (
            <p>
              <b>Status:</b> {item.status}
            </p>
          )}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (moduleType === "Pending Applicants") {
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = portalAccociatedApplicants.length;
      configure.currentPage = 1;
      configure.isDropdownActions = true;
      configure.isCheckbox = true;
      setConfig(configure);
      portalAccociatedApplicants.forEach((item) => {
        item.isChecked = false;
      });
      setPortalAccociatedApplicants(portalAccociatedApplicants);
    } else if (moduleType === "Rejected Applicants") {
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = rejectedApplicants.length;
      configure.currentPage = 1;
      configure.isDropdownActions = false;
      configure.isCheckbox = false;
      setConfig(configure);
      rejectedApplicants.forEach((item) => {
        item.isChecked = false;
      });
      setRejectedApplicants(rejectedApplicants);
    } else if (moduleType === "Associated Applicants") {
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = AssociatedApplicants.length;
      configure.currentPage = 1;
      configure.isDropdownActions = true;
      configure.isCheckbox = true;
      setConfig(configure);
      AssociatedApplicants.forEach((item) => {
        item.isChecked = false;
      });
      setAssociatedApplicants(AssociatedApplicants);
    }
  }, [moduleType]);

  useEffect(() => {
    if (
      AssociatedApplicantById !== null &&
      AssociatedApplicantById !== undefined
    ) {
      setIsRightSidePannel(true);
      setComponentType("ApplicantProfile");
      handleTooltipDismiss();
      setProfileData(AssociatedApplicantById);
      // let navigateTo = "";
      // if (getApplicantPath().includes('applicants/list')) {
      //   const appliantObj = { id: AssociatedApplicantById.applicantId };
      //   dispatch(setSelectedApplicant({ applicantDetails: appliantObj }));
      //   navigateTo = `/ats/layout/applicants/list/landing`;
      // } else {
      //   navigateTo = `/ats/layout/applicants/view/${AssociatedApplicantById.applicantId}`;
      // }
      // setPannelobj({
      //   ...pannelobj,
      //   title: `${AssociatedApplicantById.applicantName} (${AssociatedApplicantById.applicantCode})`,
      //   navigateTo: navigateTo,
      // });
      setPannelobj({
        ...pannelobj,
        title: `${AssociatedApplicantById.applicantName} (${AssociatedApplicantById.applicantCode})`,
        navigateTo: `/ats/layout/applicants/view/${AssociatedApplicantById.applicantId}`,
      });
      dispatch(_ser.getAssociatedApplicantByIdStartReducer(initalState));
    }
  }, [AssociatedApplicantById]);

  useEffect(() => {
    if (sendEmail === 200 || ClientBulkEmail === 200) {
      let Data = [...AssociatedApplicants];
      Data.forEach((item) => {
        item.isChecked = false;
      });
      setAssociatedApplicants(Data);
      setConfig({ ...config });
      dispatch(_userSer.SendEmailStartReducer(initalState));
      dispatch(_userSer.ClientBulkEmailStartReducer(initalState));
    }
  }, [sendEmail, ClientBulkEmail]);

  const onReceiveActionHandler = async (type) => {
    if (type === "Add Associate Applicants") {
      handleAddAssociateApplicants();
    } else {
      const sourceList = getSelectedList();
      const selectedItems = getCheckedItems(sourceList);
      if (!selectedItems.length) {
        return dispatch(
          updateSnackbar({ type: "error", message: "No record selected" }),
        );
      }
      setSelectedAction(type);
      switch (type) {
        case "Delete":
          handleDelete(selectedItems);
          break;
        case "confirmDel":
          handleConfirmDelete(selectedItems);
          break;
        case "Accept":
        case "Reject":
          handleStatusUpdate(selectedItems, type);
          break;
        case "Download":
        case "download":
        case "view":
          handleDownloadOrView(selectedItems, type);
          break;
        case "Send E-mail":
          handleSendEmail(selectedItems);
          break;
        case "Update Status":
          handleBulkUpdateStatus(selectedItems);
          break;
        default:
          console.warn("Unhandled action type:", type);
      }
      setSelectedAction("");
    }
    if(tooltipCardId !== null){
      handleTooltipDismiss();
    }
  };

  const handleAddAssociateApplicants = () => {
    setComponentType("AssociatedApplicants");
    setIsRightSidePannel(true);
    setSearchQuery("");
  };

  const handleBulkUpdateStatus = (object) => {
    setIsBulkUpdateStatus(true);
    setbulkUpdateStatusArray(object);
  };

  const handleSendEmail = (object) => {
    setIsAssociatedProfile(true);
    setSelectedApplicants(object);
    setIsGenerateTemplate(true);
    setApplicantCodes(object);
    setApplicantDocumentsDetails(
      object.map((item) => ({
        docid: item.docsid,
        docName: item.docName,
        docfileType: item.docfileType,
        updatedDate: GetTimeZone(item.updatedDate),
        uploadedBy: item.submittedByUser,
      })),
    );
  };

  const handleDownloadOrView = (object, type) => {
    setProfileData(object);
    DownloadFileFromS3(object, type);
    if (type === "view") {
      setIsDocumentView(true);
    }
  };

  const handleStatusUpdate = (object, type) => {
    const jobCode = selectedJobCode;
    const newArray = object.map((obj) => ({
      id: obj.asscoId,
      status: type === "Accept" ? "Associated" : "Rejected",
      applicantCode: obj.applicantCode,
      applicantId: obj.applicantID?.toString() || "",
      jobCode,
    }));
    dispatch(
      _ser.updateCandidateStatusAsync(selectedJobId, { data: newArray }),
    );
  };

  const handleDelete = (object) => {
    setShowDeleteConfirm(true);
  };

  const getSelectedList = () => {
    if (moduleType === "Associated Applicants")
      return searchQuery ? (filteredList || []) : (AssociatedApplicants || []);
    if (moduleType === "Pending Applicants")
      return searchQuery ? (filteredList || []) : (portalAccociatedApplicants || []);
    return [];
  };

  const getCheckedItems = (list) => list.filter((x) => x.isChecked);

  const handleConfirmDelete = async (object) => {
    setShowDeleteConfirm(false);
    DeleteAssociatedJobseeker(object);
  };

  const showViewAnswer = (object) => {
    let Obj = {
      cs_id: object.cs_id ? object.cs_id : 0,
      job_id: selectedJobId,
      applicant_id: object.applicantID,
    };
    dispatch(_sercloud.getQuestionsAnswersReducerAsync(Obj));
  };

  useEffect(() => {
    if (updateCandidateCode === 200) {
      dispatch(_ser.updateCandidateStatusStartReducer(initalState));
      dispatch(_ser.jobpostingsbyidAsync(selectedJobId));
      onReceiveProps("associateApplicant");
      setSearchQuery('');
    }
  }, [updateCandidateCode]);

  useEffect(() => {
    if (responseOfQuestionAnswer && responseOfQuestionAnswer.length > 0) {
      let newObj = JSON.parse(JSON.stringify(responseOfQuestionAnswer));
      newObj.forEach((item) => {
        item.answer = JSON.parse(item.answer);
      });
      setQuestionsData(newObj);
      setIsRightSidePannel(true);
      setComponentType("Questions&Answers");
      dispatch(_sercloud.getQuestionsAnswersStartReducer({}));
    }
  }, [responseOfQuestionAnswer]);

  const DeleteAssociatedJobseeker = async (object) => {
    if (object.SourcedFrom === "Cloudsourcing") {
      object["portalassociatedApplicants"] = "csassociatedApplicants";
    } else if (object.SourcedFrom === "Employee Portal") {
      object["portalassociatedApplicants"] = "eassociatedApplicants";
    } else if (object.SourcedFrom === "Vendorsourcing") {
      object["portalassociatedApplicants"] = "vsassociatedApplicants";
    } else {
      object["portalassociatedApplicants"] = "associatedApplicants";
    }
    let array = object.map((i) => i.asscoId);
    let deleteIds = { ids: array };
    dispatch(
      _ser.deleteAssociatedJobseekerAsync(
        selectedJobId,
        object[0].applicantID,
        deleteIds,
      ),
    );
  };

  useEffect(() => {
    if (DeleteAssociatedJobseekercode === 200) {
      setSearchQuery('');
      onReceiveProps("associateApplicant");
      dispatch(_ser.deleteAssociatedJobseekerStartReducer(initalState));
      dispatch(_ser.jobpostingsbyidAsync(selectedJobId));
    }
  }, [DeleteAssociatedJobseekercode]);

  const onReceivePropsHandler = (pannel, load) => {
    if (load == "getFetch") {
      setIsRightSidePannel(pannel);
      setSearchQuery('');
      onReceiveProps("associateApplicant");
      dispatch(_ser.jobpostingsbyidAsync(selectedJobId));
    } else if (load === "close") {
      setIsAssociatedProfile(pannel)
      setIsBulkuploadResponse(pannel);
      setIsRightSidePannel(pannel);
      setIsBulkUpdateStatus(pannel);
      setComponentType("");
      setIsGenerateTemplate(pannel);
      setIsDocumentView(pannel);
      setSearchQuery("");
      setSearchQuery("");
      dispatch(_ser.jobpostingsbyidAsync(selectedJobId));
      // setApplicantCodes([]);
      // if (componentType === "ApplicantProfile") {
        // onReceiveProps("associateApplicant");
      // }
    } else if (load === "download") {
      DownloadFileFromS3(pannel, load);
    } else if (load === "view") {
      setIsRightSidePannel(false);
      setIsDocumentView(true);
      DownloadFileFromS3(pannel, load);
    } else if (
      load === "Please select client to send an email to hiring manager"
    ) {
      setApplicantCodes([]);
      let Data = [...AssociatedApplicants];
      Data.forEach((item) => {
        item.isChecked = false;
      });
      setAssociatedApplicants(Data);
      setTimeout(() => {
        dispatch(_ser.listjobpostingsStartReducer(initalState));
        dispatch(_ser.jobpostingsbyidAsync(selectedJobId));
        dispatch(updateSnackbar({ type: "error", message: load }));
      }, 500);
    }
  };

  const onChangeModule = (type) => {
    if (type == "Associated Applicants") {
      setModuleType("Associated Applicants");
    } else if (type == "Pending Applicants") {
      setModuleType("Pending Applicants");
    } else if (type == "Rejected Applicants") {
      setModuleType("Rejected Applicants");
    }
    setCurrentPage(1);
    setSearchQuery("");
  };

  const DownloadFileFromS3 = async (object, type) => {
    type = type === "view" ? "preview" : "download";
    setSelectedDoc(object);
    let Url = object.filePath;
    setDocUrl(Url);
    dispatch(
      _serapplicant.downloaddocumentAsync(
        object.applicantId,
        type,
        object.documentId,
      ),
    );
    setActionType(type);
  };

  const guessNameFromUrl = (url) => {
    try {
      return decodeURIComponent(
        new URL(url).pathname.split("/").pop() || "download",
      );
    } catch {
      return "download";
    }
  };

  useEffect(() => {
    if (!docData) return;

    const run = async () => {
      try {
        if ((actionType || "").toLowerCase() === "download") {
          if (typeof docData === "string") {
            const filename =
              selectedDoc?.fileName ||
              selectedDoc.fileName ||
              guessNameFromUrl(docData);
            // force download via Blob
            const res = await fetch(docData, {
              cache: "no-store",
              credentials: "omit",
            });
            const blob = await res.blob();
            const href = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = href;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(href);
          } else {
            const url = selectedDoc?.filePath ?? "";
            const extention = url?.substring(url?.lastIndexOf(".") + 1);

            const filename =
              selectedDoc?.fileName ||
              selectedDoc.fileName ||
              `document.${(extention || "pdf").toLowerCase()}`;
            const blob =
              docData instanceof Blob ? docData : new Blob([docData]);
            const href = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = href;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(href);
          }
        } else {
          setPreviewType(docData);
        }
      } finally {
        dispatch(_serapplicant.downloaddocumentStartReducer(initalState));
      }
    };

    run();
  }, [docData]);

  const handleSearch = (query, moduleType, actionType) => {
    setSearchQuery(query);
    // Minimum validation (only on Enter/search click)
    if (actionType === "onRequestSearch") {
      if (query.length > 0 && query.length < 2) {
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Required Minimum 2 Characters",
          }),
        );
        return;
      }
    }
    // Get source list based on module
    let sourceList = [];
    if (moduleType === "Associated Applicants") {
      sourceList = AssociatedApplicants;
    } else if (moduleType === "Pending Applicants") {
      sourceList = portalAccociatedApplicants;
    } else if (moduleType === "Rejected Applicants") {
      sourceList = rejectedApplicants;
    }
    // If empty search → reset
    if (!query) {
      setFilteredList(sourceList);
      setCurrentPage(1);
      return;
    }
    // Filter logic
    const lowerQuery = query.toLowerCase();
    const filtered = sourceList.filter((item) => {
      return (
        item.applicantCode?.toLowerCase().includes(lowerQuery) ||
        item.Applicantname?.toLowerCase().includes(lowerQuery) ||
        item.ContactNumber?.toLowerCase().includes(lowerQuery) ||
        item.emailId?.toLowerCase().includes(lowerQuery)
      );
    });
    setFilteredList(filtered);
    setCurrentPage(1);
  };

  return (
    <div className="associated-card-view">
      { (componentType === "AssociatedApplicants" ? !isRightSidePannel : true) && (
      <>
        <div className="contentSection" style={{ padding: 0 }}>
        <div className="drop_down">
          <div className="groupButtons-new">
            <ButtonGroup variant="contained">
              {mainDropdownList.map((list, i) => (
                <Button
                  key={i}
                  className={moduleType === list.type ? "active" : ""}
                  onClick={() => onChangeModule(list.type)}
                >
                  {list.label} ({dataMap[list.type]?.length || 0})
                </Button>
              ))}
            </ButtonGroup>
          </div>
        </div>
        <div className="searchbar-section">
          <Searchbar
            value={searchQuery}
            placeholder="Search By Id, Name, Email ID, Contact Number"
            onChange={(value) => handleSearch(value, moduleType, "onChange")}
            onEnter={(value) => {
              let modifyConfig = { ...config };
              modifyConfig.currentPage = 1;
              setConfig(modifyConfig);
              handleSearch(value, moduleType, "onRequestSearch");
            }}
            onClear={() => handleSearch("", moduleType, "onCancelSearch")}
          />
        </div>
        <div style={{ width: "230px" }}></div>
        </div>
       {moduleType === "Associated Applicants" ? (
        <>
          <div
            className="contentSection"
            style={{ float: "right", marginTop: "-19px" }}
          >
            <FloatingMenu
              config={{}}
              floatingMenuOptions={AssociateAppliantMenuOptions}
              onReceiveActionHandler={onReceiveActionHandler}
              storedTheme={storedTheme}
            />
          </div>
          <div>
            {renderCards()}
            <Pagination
              currentPage={currentPage}
              totalCount={currentList.length}
              pageSize={pageSize}
              onPageChange={setCurrentPage}
              className="detail-card-pagination"
            />
          </div>
        </>
       ) : moduleType === "Pending Applicants" ? (
        <>
          <div
            className="contentSection"
            style={{ float: "right", marginTop: "-19px" }}
          >
            <FloatingMenu
              config={{}}
              floatingMenuOptions={AssociateAppliantPendingMenuOptions}
              onReceiveActionHandler={onReceiveActionHandler}
              storedTheme={storedTheme}
            />
          </div>
          <div>
            {renderCards()}
            <Pagination
              currentPage={currentPage}
              totalCount={currentList.length}
              pageSize={pageSize}
              onPageChange={setCurrentPage}
              className="detail-card-pagination"
            />
          </div>
        </>
       ) : moduleType === "Rejected Applicants" ? (
        <div>
          {renderCards()}
          <Pagination
            currentPage={currentPage}
            totalCount={currentList.length}
            pageSize={pageSize}
            onPageChange={setCurrentPage}
            className="detail-card-pagination"
          />
        </div>
       ) : (
        " "
       )}
        
      </>
      )}
      
      {/* DELETE CONFIRMATION DIALOG */}
      <WarningPopup
        open={showDeleteConfirm}
        handleClose={() => setShowDeleteConfirm(false)}
        handleConfirm={() => {
          onReceiveActionHandler("confirmDel");
        }}
        details={warningPopups.DELETE_ASSOCIATE_POPUP}
      />
      <div
        className={
          componentType === "Questions&Answers"
            ? "rightsidebarbtn_question"
            : "rightsidebarbtn"
        }
      >
        {isRightSidePannel && selectedJobId && componentType !== "AssociatedApplicants" ? (
          <RightSideBar
            componentData={
              <ComponentRenderData
                JobId={selectedJobId}
                Jobcode={selectedJobCode}
                dispatch={dispatch}
                isLoad={isRightSidePannel}
                clientData={AssociatedApplicants}
                componentType={componentType}
                onReceivechildProps={onReceivePropsHandler}
                questionsData={questionsData}
                profileData={profileData}
              />
            }
            componentLayout={
              componentType === "Questions&Answers"
                  ? QAObj
                  : componentType === "ApplicantProfile"
                    ? pannelobj
                    : ""
            }
            footerImg={
              componentType === "Questions&Answers" ? (
                questionsData?.length >= 2 ? (
                  ""
                ) : (
                  <UpdateStausillus />
                )
              ) : componentType === "ApplicantProfile" ? (
                <UpdateStausillus />
              ) : (
                ""
              )
            }
            isFooter={
              !(
                componentType === "Questions&Answers" &&
                questionsData?.length >= 2
              )
            }
            onReceiveProps={onReceivePropsHandler}
          />
        ) : componentType === "AssociatedApplicants" ?(
             <ComponentRenderData
                JobId={selectedJobId}
                Jobcode={selectedJobCode}
                dispatch={dispatch}
                isLoad={isRightSidePannel}
                clientData={AssociatedApplicants}
                componentType={componentType}
                onReceivechildProps={onReceivePropsHandler}
                questionsData={questionsData}
                profileData={profileData}
              />
        ) : (null)}
      </div>
      {Boolean(isGenerateTemplate) && (
        <RightSideBar
          componentData={
            <GenerateTemplateNew
              isAssociatedProfile={isAssociatedProfile}
              applicantDetails={profileData}
              tempApplicant={applicantTemp}
              applicantCodes={applicantCodes}
              jobCode={`(${selectedJobCode})`}
              documents={applicantDocumentsDetails}
              onReceiveProps={onReceivePropsHandler}
              selectedJobId={selectedJobId}
            />
          }
          componentLayout={MailOBJ}
          onReceiveProps={onReceivePropsHandler}
        />
      )}

      {Boolean(isBulkuploadResponse) && (
        <div id="bulkUploadResults">
          <RightSideBar
            componentData={
              <BulkComponentRenderData
                data={bulkUploadMessage}
                onReceivechildProps={onReceivePropsHandler}
              />
            }
            componentLayout={bulkResponseObj}
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      )}
      {Boolean(isBulkUpdateStatus) && (
        <div id="bulkUploadStatus">
          <RightSideBar
            componentData={
              <BulkUpdateStatus
                data={candidateStatusValues}
                jobId={selectedJobId}
                jobCode={selectedJobCode}
                bulkUpdateStatusArray={bulkUpdateStatusArray}
                onReceivechildProps={onReceivePropsHandler}
              />
            }
            componentLayout={UpdateStatusObj}
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      )}
      {Boolean(isDocumentView) && (
        <div id="documentView" className={`jobAssociateApplicant-${getFileExtension(previewType)}`}>
          <RightSideBar
            className="associationProfileDocView"
            componentData={
              <ViewDocument
                data={profileData}
                previewType={previewType}
                onReceivechildProps={onReceivePropsHandler}
              />
            }
            componentLayout={docViewObj}
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      )}
      <EmailDeliverySummary candidateMailId={applicantCodes[0]?.emailId}/>
    </div>
  );
};

const ComponentRenderData = React.memo(
  ({
    dispatch,
    JobId,
    Jobcode,
    clientData,
    onReceivechildProps,
    componentType,
    isLoad,
    questionsData,
    profileData,
  }) => {
    const [jobData, setjobData] = useState(null);
    const [AlljobData, setAlljobData] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [findconfig, setFindconfig] = useState(findconfiguration);
    const [aiconfig, setaiconfig] = useState(aiconfiguration);
    const [searchValue, setSearchValue] = useState("");
    const [value, setValue] = useState("3");
    const [totalRecords, setTotalRecords] = useState(null);
    const navigate = useNavigate();
    const [manualApplicatsConfirmPopup, setManualApplicatsConfirmPopup] =
      useState(false);
    const [updateProfileWithNewResume, setUpdateProfileWithNewResume] =
      useState(null);
    const [sourceId, setSourceId] = useState(0);
    const [defaultFile, setDefaultFile] = useState(null);
    const [keyword, setKeyword] = useState("");
    const [duplicateApplicatsConfirmPopup, setDuplicateApplicatsConfirmPopup] =
      useState(false);
    const [
      twoDuplicateApplicatsConfirmPopup,
      setTwoDuplicateApplicatsConfirmPopup,
    ] = useState(false);
    const [skipId, setSkipId] = useState(null);
    const [skipName, setSkipName] = useState(null);
    const [profileValue, setProfileValue] = useState("1");
    const [user, setUser] = useState([]);
    const [candidateStatusValues, setCandidateStatusValues] = useState([]);
    const [AuditlogData, setAuditlogData] = useState([]);
    const [profileUpdate, setProfileUpdate] = useState("");
    const [updateStatus, setUpdateStatus] = useState("");
    const [noteType, setNoteType] = useState("Call");
    const [jobObj, setJobObj] = useState({ jobId: JobId, jobCode: Jobcode });
    const [isUpdateResumeOpen, setIsUpdateResumeOpen] = useState(false);
    const [resumeVersions, setResumeVersions] = useState([]);
    const [isResumeVersionsLoading, setIsResumeVersionsLoading] = useState(false);
    const [selectedResumeDocId, setSelectedResumeDocId] = useState(null);
    const [selectedProject, setSelectedProject] = useState('');
    const [projectsList, setProjectsList] = useState([]);

    const selectedJobId = JobId;
    const cancelRef = useRef(null);

    const SearchAffinda = useSelector((state) => state.SearchAffinda.data);
    const showLoader = useSelector((state) => state.Loader);
    const UploadDocCode = useSelector((state) => state.UploadDocuments.data);
    const code = useSelector((state) => state.AddApplicantNotes.data);
    const GetListApplicants = useSelector(
      (state) => state.SearchApplicantsWithPaging.data,
    );
    const customFieldsData = useSelector((state) => state.CustomFields.data);
    const updateCandidateCode = useSelector(
      (state) => state.UpdateCandidateStatus.data,
    );
    const DelAssociatedJobcode = useSelector(
      (state) => state.DeleteAssociatedJob.data,
    );
    const AddAssociatedjobsCode = useSelector(
      (state) => state.AddAssociatedjobs.data,
    );
    const resumeVersionsData = useSelector((state) => state.GetResumeswithMatchPercentage.data);

    const projects = useSelector((state) => state.GetProjectsByJobPostingId.data);

    useEffect(() => {
      const selectedIdsArray = (clientData || []).map((x) => ({
        id: x.applicantID,
        docId: x.docsid,
      }));
      setSelectedIds(selectedIdsArray);
    }, [clientData]);

    const GetData = async (obj) => {
      let jobIdentifier = localStorage.getItem("JobIdentifier");
      if (jobIdentifier !== "null") {
        dispatch(updateGlobalLoading(false));
        dispatch(_ser.searchAffindaAsync(obj, jobIdentifier));
        setaiconfig({ ...aiconfig, currentPage: obj.currentPage || 1 });
      }
    };

    useEffect(() => {
      if (SearchAffinda !== null && SearchAffinda !== undefined) {
        setjobData(null);
        if (SearchAffinda.length > 0) {
          const myData = [];
          let applicantsData = JSON.parse(JSON.stringify(SearchAffinda));
          applicantsData.forEach((e) => {
            if (e.length > 0) {
              myData.push(...e);
            } else if (typeof e === "object" && e.id) {
              if (e.skills) {
                const parsed = JSON.parse(e.skills);
                const destructerSkils = Array.isArray(parsed) ? parsed.map((x) => x.name) : [];
                e['matchedSkills'] = destructerSkils.slice(0, 3);
              }
              myData.push(e);
            }
          });
          setjobData(myData);
          dispatch(_ser.searchAffindaStartReducer(initalState));
        } else {
          setjobData([]);
        }
      }
    }, [SearchAffinda]);

    const onActionHandler = (id, type) => {
      if (type === "delete" || type === "remove") {
        DeleteAssociatedjobs(id);
        setSelectedIds(selectedIds.filter((x) => x.id !== id.id));
      } else if (type === "add" || type === "Add") {
        AddAssociatedjobs(id);
      } else if (type === "searchResult" && parseInt(value) === 2) {
        if (id.keyword !== "") {
          setSearchValue(id.keyword ? id.keyword : id);
          getListApplicants(id);
        } else {
          if (cancelRef.current) cancelRef.current();
          setSearchValue(null);
          setAlljobData([]);
          setFindconfig({ ...findconfig, totalRecords: 0 });
        }
      }
    };

    const DeleteAssociatedjobs = async (obj) => {
      let data = {};
      dispatch(_ser.deleteAssociatedJobAsync(JobId, obj, data));
    };

    useEffect(() => {
      if (DelAssociatedJobcode === 200) {
        onReceivechildProps(true, "getFetch");
        dispatch(_ser.deleteAssociatedStartReducer(initalState));
      }
    }, [DelAssociatedJobcode]);

    const AddAssociatedjobs = async (obj) => {
      let userInfo = await GetUserInfo();
      let userId = await getAttributes();
      const payload = {
        applicantCode: obj.applicantCode,
        docId: obj.docId ?? obj.docsId ?? null,
        firstName: userId[0].firstName,
        id: obj.id,
        lastName: userId[0].lastName,
        score: obj.score ? obj.score : "",
        source: obj.source ? obj.source : "ATS",
        status: "Associated",
        submittedBy: userInfo[0].id,
      };
      dispatch(_ser.addAssociatedjobsAsync(JobId, payload, "applicant"));
    };

    useEffect(() => {
      if (AddAssociatedjobsCode === 200) {
        dispatch(_ser.addAssociatedjobsStartReducer(initalState));
        onReceivechildProps(true, "getFetch");
      }
    }, [AddAssociatedjobsCode]);

    useEffect(() => {
      if (!isLoad) return;
      try {
        const subpathObj = JSON.parse(
          localStorage.getItem("subpathObj") || "[]",
        );
        const jobCodeNum = Number(Jobcode);
        const isMatch = subpathObj.some(
          (x) => x.id === jobCodeNum && x.type === "Job Code",
        );
        if (isMatch) {
          const jobIdentifier = localStorage.getItem("JobIdentifier");
          if (jobIdentifier) {
            setKeyword(jobIdentifier);
          }
        }
      } catch (error) {
        console.error("Error parsing subpathObj:", error);
      }
    }, [Jobcode, isLoad]);

    const getListApplicants = (obj) => {
      dispatch(updateGlobalLoading(false));
      if (cancelRef.current) cancelRef.current();
      const source = axios.CancelToken.source();
      cancelRef.current = source.cancel;
      let fields = "docs";
      let url = undefined;
      dispatch(
        _serapplicant.searchApplicantsWithPagingAsync(
          obj.limit,
          obj.offset,
          obj.keyword,
          url,
          fields,
          source.token,
        ),
      ).catch((err) => {
        if (axios.isCancel(err)) {
        } else {
          console.error(err);
        }
      });
    };

    useEffect(() => {
      return () => {
        if (cancelRef.current) cancelRef.current();
      };
    }, []);

    useEffect(() => {
      if (GetListApplicants?.rows && GetListApplicants?.rows?.length > 0) {
        const myData = [];
        GetListApplicants?.rows?.forEach((e) => {
          if (e.length > 0) {
              myData.push(...e);
            } else if (typeof e === "object" && e.id) {
              let updatedE = { ...e };
              if (e.skills) {
                const parsed = safeJsonParse(JSON.parse(e.skills));
                const destructerSkils = Array.isArray(parsed) ? parsed.map((x) => x.name) : [];
                updatedE['matchedSkills'] = destructerSkils.slice(0, 3);
              }
              myData.push(updatedE);
            }
        });
        setAlljobData(myData);
        setFindconfig({
          ...findconfig,
          totalRecords: GetListApplicants.total_count,
        });
        setTotalRecords(null);
        dispatch(
          _serapplicant.searchApplicantsWithPagingStartReducer(initalState),
        );
      } else if (GetListApplicants?.rows?.length === 0) {
        setAlljobData([]);
      }
    }, [GetListApplicants]);

    const handleChange = (event, Value) => {
      setAlljobData([]);
      setValue(Value);
      if (parseInt(Value) === 1) {
        setjobData(null);
        let limitObj = { limit: 50, offset: 1 };
        GetData(limitObj);
      }
    };

    const onReceivePropsHandler = (pannel, load) => {
      onReceivechildProps(pannel, load);
    };

    const onManualuploadHandler = () => {
      let json = {
        Applicants: {
          firstName: "",
          lastName: "",
          phone: "",
          emailId: "",
          alternateContactNumber: "",
          resumesourceId: sourceId,
        },
        totalExperience: null,
        linkedIn: "",
        educationDetails: [],
        workExp: [],
        skillDetails: [],
        certification: [],
        identifier: "",
        customFields: JSON.stringify([]),
        jobDescription: "",
        source: sourceId,
        id: 0,
      };
      navigate("/ats/layout/applicants/create", {
        state: {
          applicant: json,
          sourceId: sourceId,
          uploadfile: defaultFile,
          isAssociate: jobObj,
          isduplicate: false,
          isManual: true,
          associateAnyway: true,
          showLandingPage: false,
        },
      });
    };

    const onManualPopup = (isPopup, sourceId, file, obj) => {
      if (sourceId !== null && file !== null) {
        setManualApplicatsConfirmPopup(isPopup);
        setSourceId(sourceId);
        setDefaultFile(file);
        if (obj !== null) {
          setSkipId(obj.id);
          let json = {
            Applicants: obj.data.Applicants,
            totalExperience: obj.data.totalExperience
              ? obj.data.totalExperience
              : null,
            linkedIn: obj.data.linkedIn ? obj.data.linkedIn : "",
            educationDetails: obj.data.educationDetails
              ? obj.data.educationDetails
              : [],
            workExp: obj.data.workExperiences ? obj.data.workExperiences : [],
            skillDetails: obj.data.skillDetails ? obj.data.skillDetails : [],
            certification: obj.data.certifications
              ? obj.data.certifications
              : [],
            identifier: obj.data.identifier ? obj.data.identifier : "",
            jobDescription: "",
            customFields: JSON.stringify([]),
            source: sourceId,
            id: obj.id,
            oldApplicantName: obj.oldApplicantName ? obj.oldApplicantName : "",
            Resume: file,
          };
          setUpdateProfileWithNewResume(json);
          setDuplicateApplicatsConfirmPopup(true);
        }
      } else {
        setTwoDuplicateApplicatsConfirmPopup(true);
        setSkipId(obj.data.id);
        setSkipName(obj.data.name);
      }
    };

    useEffect(() => {
      if (UploadDocCode === 200) {
        ////// NEED TO CHANGE
        navigate(`/ats/layout/applicants/documents/${skipId}`);
        dispatch(_serapplicant.uploadDocumentsStartReducer(initalState));
      }
    }, [UploadDocCode, skipId]);

    ///////////////////////////////////////////////////// FOR APPLICANT PROFILE VIEW /////////////////////////////////////////

    useEffect(() => {
      let defaultPostingModules = defaultApplicantsData.filter(
        (x) => x.moduleId === "2",
      );
      if (defaultPostingModules.length > 0) {
        defaultPostingModules.forEach((list) => {
          if (list.fieldName === "Candidate status") {
            setCandidateStatusValues(list.customValues);
          }
        });
      }
    }, []);

    useEffect(() => {
      async function init() {
        let userId = await GetUserId();
        dispatch(customFieldsAsync(userId));
      }
      init();
    }, []);

    useEffect(() => {
      if (customFieldsData && customFieldsData.length > 0) {
        const array = getCandidateStatusCustomValues(customFieldsData);
        setCandidateStatusValues(array);
      }
    }, [customFieldsData]);

    const handleChangeProfile = (event, Value) => {
      setProfileValue(Value);
    };

    const handleOpenUpdateResume = () => {
      setIsUpdateResumeOpen(true);
      setSelectedResumeDocId({
        docId: profileData?.filePath ? profileData?.documentId || null : null,
        percentage: null,
      });
      setResumeVersions([]);
      setIsResumeVersionsLoading(true);
      dispatch(
        _ser.GetResumeswithMatchPercentageAsync(
          selectedJobId,
          profileData?.applicantId,
        ),
      );
    };

    useEffect(() => {
      if (resumeVersionsData === null || resumeVersionsData === undefined) return;
      const mapped = resumeVersionsData.map((doc) => ({
        docId: doc.docsId,
        fileName: doc.documentPath
          ? doc.documentPath.split("/").pop()
          : `${doc.documentName}${doc.fileType ? `.${doc.fileType}` : ""}`,
        isCurrent: doc.docsId === profileData?.documentId,
        uploadedBy: doc.documentSubmittedBy,
        uploadedOn: doc.docscreatedDate ? GetTimeZone(doc.docscreatedDate) : "",
        matchPercentage:
          doc.matchPercentage == null || doc.matchPercentage === -1
            ? -1
            : doc.matchPercentage,
      }));
      setResumeVersions(mapped);
      setIsResumeVersionsLoading(false);
      dispatch(_ser.GetResumeswithMatchPercentageStartReducer(initalState));
    }, [resumeVersionsData]);

    const handleCloseUpdateResume = () => {
      setIsUpdateResumeOpen(false);
      setResumeVersions([]);
      setSelectedResumeDocId(null);
    };

    const handleUpdateResumeConfirm = async () => {
      let userInfo = await GetUserInfo();
      const data = {
        assocId : profileData?.assocId,
        newDocId: selectedResumeDocId?.docId ?? null,
        score: selectedResumeDocId?.percentage ?? "",
        userId: userInfo[0].id,
      };
      dispatch(_ser.updateAssociatedResumeAsync(data));
    };

    const updateCode = useSelector((state)=>state.UpdateAssociatedResume.data);

    useEffect(()=>{
      if(updateCode === 200){
        handleCloseUpdateResume();
        dispatch(_ser.updateAssociatedResumeStartReducer(initalState));
        setTimeout(() => {
          dispatch(_ser.getAssociatedApplicantByIdAsync(profileData?.assocId));
          dispatch(_ser.getAssociatedApplicantsAsync(selectedJobId));
        }, 1200);
      }
    },[updateCode])

    useEffect(() => {
      if (profileData?.applicantId) {
        setUser(profileData?.notesData || []);
        let auditLogData = (profileData?.auditData || []).map((item) => {
          return {
            ...item,
            createdAt: item.createdAt
              ? GetTimeZone(item.createdAt)
              : item.createdAt,
          };
        });
        setAuditlogData(auditLogData);
      }
    }, [profileData]);

    const onChangeHandler = (value, type) => {
      let obj = JSON.parse(JSON.stringify(initialData));
      if (type == "noteText" && value.data.trim().length !== 0) {
        obj[type] = value.data;
        localStorage.setItem("ApplicantText", JSON.stringify(obj.noteText));
      } else if (type === "noteType") {
        setNoteType(value);
        obj.noteText = JSON.parse(localStorage.getItem("ApplicantText"));
      } else if (type === "candidateStatus") {
        setUpdateStatus(value);
      }
      setProfileUpdate(obj);
    };

    const HandleSubmit = async (event) => {
      if (updateStatus !== "") {
        let jobId = selectedJobId;
        const statusId = getCandidateStatusId(
          updateStatus,
          candidateStatusValues,
        );
        let updateData = {
          data: [
            {
              id: profileData.assocId.toString(),
              status: statusId,
              applicantCode: profileData.applicantCode,
              applicantId: profileData.applicantId.toString(),
              jobCode: Jobcode,
            },
          ],
        };
        dispatch(_ser.updateCandidateStatusAsync(jobId, updateData));
      } else {
        dispatch(updateSnackbar({ type: "error", message: "Change status" }));
      }
    };

    useEffect(() => {
      if (updateCandidateCode === 200) {
        dispatch(_ser.updateCandidateStatusStartReducer(initalState));
        onReceivechildProps(false, "getFetch");
        dispatch(_ser.jobpostingsbyidAsync(selectedJobId));
      }
    }, [updateCandidateCode]);

    useEffect(() => {
      if (selectedJobId) {
        dispatch(_projectSer.getProjectsByJobPostingIdAsync(selectedJobId));
      }
    }, [selectedJobId]);
    
      useEffect(() => {
        if (projects) {
          if (Array.isArray(projects)) {
            setProjectsList(projects);
          } else if (projects.rows && Array.isArray(projects.rows)) {
            setProjectsList(projects.rows);
          } else if (projects.projects && Array.isArray(projects.projects)) {
            setProjectsList(projects.projects);
          }
        } else {
          setProjectsList([]);
        }
      }, [projects]);

    const HandleSubmitNote = async (event) => {
      if (profileUpdate.noteText) {
        const userInfo = await getUserDetails();
        if (noteType === 'Public' && !selectedProject) {
          dispatch(updateSnackbar({ type: 'error', message: 'Project is required' }));
          return;
        }
        let obj = {
          notes: profileUpdate.noteText,
          noteType: noteType,
          moduleType: "applicants",
          moduleId: profileData.applicantId,
          userId: userInfo.userId,
          firstName: userInfo.firstName,
          lastName: userInfo.lastName,
        };
        obj["subModuleId"] = noteType === 'Public' ? (selectedProject || null) : null;
        dispatch(_serapplicant.addNotesAsync(obj));
        localStorage.removeItem("ApplicantText");
      } else {
        dispatch(
          updateSnackbar({ type: "error", message: "Please add notes" }),
        );
      }
    };

    useEffect(() => {
      if (code === 200) {
        dispatch(_serapplicant.addNotesStartReducer(initalState));
        onReceivechildProps(false, "getFetch");
        setProfileUpdate("");
      }
    }, [code]);

    const storedTheme = JSON.parse(localStorage.getItem("themeSettings")) || "";

    return (
      <>
        {componentType === "AssociatedApplicants" && (
          <div className={componentType !== "AssociatedApplicants" ? "tabs" : "tabs tablabel_underline"}>
            <Box
              sx={{
                width: "100%",
                typography: "body1",
                color: "#3B4046",
                background: "#FFFFFF 0% 0% no-repeat padding-box",
                border: "1px solid #DCDCDC",
                borderRadius: "7px",
                opacity: 1,
                minHeight: "70vh"
              }}
            >
              <TabContext value={value}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: 0, width: "100%", pr: 2 }}>
                  <TabList
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                    className={componentType !== "AssociatedApplicants" ? "tabsvalue" : "noBottomBorder"}
                    sx={{ flexGrow: 1 }}
                  >
                    <Tab label="Add new applicant" value="3" />
                    <Tab label="AI matched applicants" value="1" />
                    <Tab label="Find applicants" value="2" />
                  </TabList>
                  <IconButton
                    className="crossIconTab"
                    onClick={() => {
                      onReceivechildProps(false, "close"); 
                      setjobData([]); 
                      setAlljobData([]);
                      setValue("3");
                    }}
                    sx={{
                      color: "#f44336 !important",
                    }}
                  >
                    <CloseIcon sx={{ fontSize: 24 }} />
                  </IconButton>
                </Box>
                <TabPanel value="1">
                  <div className={componentType === "AssociatedApplicants" ? "cardViewAssociatedApplicants" : ""}>
                    {showLoader.value && !showLoader.isGlobalLoading ? (
                      <Loader />
                    ) : (
                      ""
                    )}
                    {jobData && jobData.length > 0 ? (
                      // <AssociateCards
                      //   data={jobData}
                      //   showSearchBar={false}
                      //   selectedItems={selectedIds}
                      //   isAImatched={true}
                      //   searchKeyWord="Search by Applicant code, Name"
                      //   navigateTo="/ats/layout/applicants/view/" ///////  NEED TO CHANGE
                      //   config={aiconfig}
                      //   componentType="AssociatedApplicants"
                      //   onReceiveHandler={(Item, obj) =>
                      //     onActionHandler(Item, obj)
                      //   }
                      // />
                      <Grid container spacing={3} >
                        <ApplicantCardNew
                          moduleType="AssociatedApplicants"
                          data={jobData}
                          selectedApplicantIds={selectedIds?.map((x) => x.id) ?? []}
                          onReceiveProps={(selectedItem, type) =>
                            onActionHandler(selectedItem, type)
                          }
                        />
                      </Grid>
                    ) : (
                      !(showLoader.value && !showLoader.isGlobalLoading) && (
                        <div>
                          <div className="nodatasection nodataSection">
                            <img
                              src={
                                process.env.PUBLIC_URL + "/assests/nodata.svg"
                              }
                              alt="noResult"
                            />
                            No AI match applicants
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </TabPanel>
                <TabPanel value="2">
                  <div className={componentType === "AssociatedApplicants" ? "cardViewAssociatedApplicants" : "mt-5"} style={{ marginTop: "90px" }}>
                    {showLoader.value && !showLoader.isGlobalLoading ? (
                      <Loader />
                    ) : (
                      ""
                    )}
                    {AlljobData ? (
                      // <AssociateCards
                      //   data={AlljobData}
                      //   selectedItems={selectedIds}
                      //   isAImatched={false}
                      //   searchKeyWord="Search by Applicant code, Name"
                      //   navigateTo="/ats/layout/applicants/view/" /////  NEED TO CHANGE
                      //   config={findconfig}
                      //   componentType="AssociatedApplicants"
                      //   onReceiveHandler={(Item, obj) =>
                      //     onActionHandler(Item, obj)
                      //   }
                      // />
                      <Grid container spacing={3} >
                      <ApplicantCardNew
                          moduleType="FindAssociatedApplicants"
                          data={AlljobData}
                          selectedApplicantIds={selectedIds?.map((x) => x.id) ?? []}
                          associatedDocIds={Object.fromEntries((selectedIds || []).map(x => [x.id, x.docId]))}
                          onReceiveProps={(selectedItem, type) =>
                            onActionHandler(selectedItem, type)
                          }
                          searchKeyWord="Search by Applicant code, Name"
                          totalRecordsProp={findconfig.totalRecords}
                        />
                        </Grid>
                    ) : (
                      <div>
                        <div className="nodatasection nodataSection">
                          <img
                            src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
                            alt="noResult"
                          />
                          No Find Applicants
                        </div>
                      </div>
                    )}
                  </div>
                </TabPanel>
                <TabPanel value="3">
                  {/* className="pannelContent" */}
                  <div>
                    <ApplicantsRenderData
                      onReceivechildProps={onReceivePropsHandler}
                      onManualPopup={onManualPopup}
                      isAssociate={jobObj}
                    />
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        )}
        {/* ///////////////////////// FOR APPLICANT PROFILE VIEW //////////////////// */}
        {componentType === "ApplicantProfile" && (
          <div className="tabs">
            <Box
              sx={{
                width: "100%",
                typography: "body1",
                color: "#3B4046",
                marginTop: "-35px",
              }}
            >
              <TabContext value={profileValue}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList
                    onChange={handleChangeProfile}
                    aria-label="lab API tabs example"
                    className="tabsvalue"
                  >
                    <Tab label="Details" value="1" />
                    <Tab label="Notes" value="2" />
                    <Tab label="Audit Information" value="3" />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <div className="jobsdataView">
                    <div>
                      <tr>
                        <td>Applicant Name</td>
                        <td>:</td>
                        <td>{profileData.applicantName}</td>
                      </tr>
                      <tr>
                        <td>Contact Number</td>
                        <td>:</td>
                        <td>
                          {profileData.contactNumber}
                          {profileData.alternateContactNumber
                            ? ` / ${profileData.alternateContactNumber}`
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <td>E-mail</td>
                        <td>:</td>
                        <td>{profileData.email}</td>
                      </tr>
                      <tr>
                        <td>Status</td>
                        <td>:</td>
                        <td>{profileData.status}</td>
                      </tr>
                    </div>
                    <div>
                      <div className="pdfView">
                        {profileData?.filePath ? (
                          profileData.filePath.includes(".pdf") ? (
                            <img
                              src={
                                process.env.PUBLIC_URL + "/assests/img/pdf.svg"
                              }
                              alt=""
                              className="pdficonView"
                            />
                          ) : (
                            <img
                              src={
                                process.env.PUBLIC_URL + "/assests/img/docx.svg"
                              }
                              alt=""
                              className="pdficonView"
                            />
                          )
                        ) : (
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assests/img/no-document.svg"
                            }
                            alt=""
                            className="pdficonView"
                          />
                        )}

                        <div className="iconsView">
                          {profileData?.filePath && (
                            <>
                              <Button
                                variant="icon"
                                className="iconView"
                                onClick={() =>
                                  onReceivePropsHandler(profileData, "view")
                                }
                              >
                                <ViewFileIcon />
                              </Button>

                              <Button
                                variant="icon"
                                className="documentdownloadiconView"
                                onClick={() =>
                                  onReceivePropsHandler(profileData, "download")
                                }
                              >
                                <DownloadIcon />
                              </Button>
                            </>
                          )}

                          <Button
                            variant="icon"
                            className="updateiconView"
                            onClick={handleOpenUpdateResume}
                          >
                            <ReloadIcon />
                          </Button>
                        </div>
                      </div>

                      {profileData?.filePath ? (
                        (profileData.uploadedBy || profileData.uploadedOn) && (
                          <div style={{ fontSize: "11px" }}>
                            {profileData.uploadedBy && (
                              <p style={{ margin: "0px", color: "#262626" }}>
                                {" "}
                                <strong
                                  style={{
                                    margin: "0px",
                                    color: "#262626",
                                    fontWeight: "500",
                                  }}
                                >
                                  Uploaded by{" "}
                                </strong>{" "}
                                : {profileData.uploadedBy}
                              </p>
                            )}
                            {profileData.uploadedOn && (
                              <p style={{ margin: "0px", color: "#262626" }}>
                                {" "}
                                <strong
                                  style={{
                                    margin: "0px",
                                    color: "#262626",
                                    fontWeight: "500",
                                  }}
                                >
                                  Uploaded on{" "}
                                </strong>
                                : {GetTimeZone(profileData.uploadedOn)}
                              </p>
                            )}
                          </div>
                        )
                      ) : (
                        <div className="noDocumentWarningText">
                          The associated document is not available as it has been deleted
                        </div>
                      )}
                    </div>
                  </div>
                  <Divider className="secline" />
                  <div className="statusdropdwnView">
                    <p>Update Status</p>
                    <div style={{ width: "25%" }}>
                      <FormControl fullWidth>
                        <Select
                          className="sourcedfrominput"
                          value={
                            updateStatus !== ""
                              ? updateStatus
                              : profileData.status
                          }
                          name="candidateStatus"
                          autoComplete="off"
                          onChange={(e) =>
                            onChangeHandler(e.target.value, "candidateStatus")
                          }
                          style={{
                            width: "85%",
                            height: "2rem",
                            borderRadius: "4px",
                          }}
                          displayEmpty
                          renderValue={(profileData) => {
                            if (
                              updateStatus === ""
                                ? profileData === "undefined"
                                : false
                            ) {
                              return <span color="gray">Select</span>;
                            } else {
                              return updateStatus === ""
                                ? profileData
                                : updateStatus;
                            }
                          }}
                        >
                          {candidateStatusValues.map((status) => (
                            <MenuItem
                              className="selectOptions"
                              key={status.id}
                              value={status.internal}
                            >
                              {status.internal}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className="updatebuttonView">
                      <Button
                        className="savebtn"
                        variant="contained"
                        size="medium"
                        type="submit"
                        onClick={HandleSubmit}
                      >
                        Update
                      </Button>
                    </div>
                  </div>

                  <Divider className="secline" />
                  <div className="typeCss">
                    <span>Note Type</span>
                    <FormControl>
                      <Select
                        className="noteTypeselect"
                        label="Select Type"
                        value={noteType}
                        autoComplete="off"
                        onChange={(e) =>
                          onChangeHandler(e.target.value, "noteType")
                        }
                      >
                        <MenuItem className="selectOptions" value={"Call"}>
                          Call
                        </MenuItem>
                        <MenuItem className="selectOptions" value={"E-mail"}>
                          E-mail
                        </MenuItem>
                        <MenuItem className="selectOptions" value={'Public'}>
                        Public
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  {noteType === "Public" && projectsList.length > 0 && (
                    <div className="public-note-warning-assoc-applicant">
                      <InfoOutlinedIcon style={{ color: '#FAAD14', fontSize: '18px', flexShrink: 0, marginTop: '-60px' }} />
                      <span className="public-note-warning-text-assoc-applicant">
                        Public notes are visible to all internal recruiters and external collaborators associated with this project through shared project links. Both recruiters and external collaborators can add and view public notes for project-related communication and updates.
                      </span>
                    </div>
                  )}
                  {noteType === "Public" && (
                    <>
                      {projectsList.length === 0 ? (
                        <div className="public-note-error">No project linked to this Applicant</div>
                      ) : (
                      <div className="note-field-row">
                        <div className="note-field-label">Select project</div>
                        <Select
                          className="projectSelectBox"
                          value={selectedProject}
                          size="small"
                          onChange={(e) => { setSelectedProject(e.target.value) }}
                          autoComplete="off"
                          displayEmpty
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 250,
                                width: 200,
                                maxWidth: 200,
                              },
                            },
                          }}
                        >
                          <MenuItem value="" disabled style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                            <em>Select Project</em>
                          </MenuItem>
                          {projectsList?.map((project) => (
                            <MenuItem
                              key={project.projectId}
                              value={project.projectId}
                              style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                            >
                              {project.name || project.projectCode}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      )}
                    </>
                  )}

                  <div id="jobDescForSMnew">
                    <CkEditor
                      data={profileUpdate.noteText}
                      initRawData={initialData.noteText}
                      autoComplete="off"
                      name="note"
                      isReadonly={false}
                      onUpdatehandler={(update) =>
                        onChangeHandler(update, "noteText")
                      }
                    />
                  </div>

                  <div className="updatebutton1">
                    <Button
                      className="savebtn"
                      variant="contained"
                      size="medium"
                      type="submit"
                      onClick={HandleSubmitNote}
                    >
                      Update
                    </Button>
                  </div>
                </TabPanel>
                <TabPanel value="2">
                  <div>
                    {user.length > 0 ? (
                      <>
                        {user.map((elem, i) => {
                          return (
                            <>
                              <div
                                className="Applicantprofilearticle"
                                style={{ position: "relative" }}
                              >
                                <div className="usericon">
                                  {elem.noteType === "Call" ? (
                                    <Notescall
                                      primaryColor={storedTheme?.secondaryColor}
                                      primaryFontColor={storedTheme?.secondaryFontColor}
                                      width={32}
                                      height={32}
                                    />
                                  ) : elem.noteType === "Public" && elem.moduleType === "projects" ? (
                                    <PersionView
                                      primaryColor={storedTheme?.secondaryColor}
                                      primaryFontColor={storedTheme?.secondaryFontColor}
                                      width={32}
                                      height={32}
                                    />
                                  ) : elem.noteType === "Public" ? (
                                    <PublicView
                                      secondaryColor={storedTheme?.secondaryColor}
                                      secondaryFontColor={storedTheme?.secondaryFontColor}
                                      width={32}
                                      height={32}
                                    />
                                  ) : (
                                    <Notesemail
                                      primaryColor={storedTheme?.secondaryColor}
                                      primaryFontColor={storedTheme?.secondaryFontColor}
                                      width={32}
                                      height={32}
                                    />
                                  )}
                                </div>
                                <div className="jobnote">
                                  <b>
                                    <span style={{ fontWeight: "500" }}>
                                      {elem.firstName + " " + elem.lastName}
                                    </span>
                                  </b>
                                  <div
                                    style={{ maxWidth: "calc(100% - 150px)" }}
                                    dangerouslySetInnerHTML={{
                                      __html: elem.notes,
                                    }}
                                  ></div>
                                  <div style={{ display: "flex", gap: "4px" }}>
                                    {elem.noteType === "Public" && (elem.projectName || elem.projectCode) && (
                                      <span style={{ color: storedTheme?.secondaryColor }} className="createdDate">
                                        {elem.projectName || elem.projectCode},
                                      </span>
                                    )}
                                    <span className="createdDate">
                                      {GetTimeZone(elem.createdAt)}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <Divider className="secline" />
                            </>
                          );
                        })}
                      </>
                    ) : (
                      <h1
                        style={{
                          fontWeight: 300,
                          lineHeight: 1.2,
                          textAlign: "center",
                          margin: "60px 0",
                          fontSize: "3rem",
                        }}
                      >
                        No notes found
                      </h1>
                    )}
                  </div>
                </TabPanel>
                <TabPanel value="3">
                  <div>
                    {AuditlogData.length > 0 ? (
                      AuditlogData.map((e) => (
                        <div className="jobsdatacss">
                          <tr>
                            <td>Name</td>
                            <td>:</td>
                            <td>{e.fullName}</td>
                          </tr>
                          <tr>
                            <td>Action Performed</td>
                            <td>:</td>
                            <td>{e.action}</td>
                          </tr>
                          <tr>
                            <td>Date and Time</td>
                            <td>:</td>
                            <td>{e.createdAt}</td>
                          </tr>
                          <tr>
                            <td>Comments</td>
                            <td>:</td>
                            <td>{e.comments}</td>
                          </tr>
                          {/* </div> */}
                          <Divider className="secline" />
                        </div>
                      ))
                    ) : (
                      <h1
                        style={{
                          fontWeight: 300,
                          lineHeight: 1.2,
                          textAlign: "center",
                          margin: "60px 0",
                          fontSize: "3rem",
                        }}
                      >
                        No auditlog found
                      </h1>
                    )}
                  </div>
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        )}
        {/* ///////////////////////// FOR APPLICANT PROFILE VIEW END/////////////////////// */}
        {componentType === "Questions&Answers" && (
          <div style={{ padding: "20px" }}>
            {questionsData.length > 0 &&
              questionsData.map((item, index) => {
                return (
                  <div
                    className="questionsarea"
                    key={index}
                    style={{
                      marginBottom: "24px",
                      border: "none",
                      marginTop: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        marginBottom: "12px",
                        textAlign: "left",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      <h4
                        style={{
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "#333",
                          margin: 0,
                          flexShrink: 0,
                        }}
                      >
                        {`${index + 1})`}
                      </h4>
                      <h4
                        style={{
                          fontSize: "18px",
                          fontWeight: 600,
                          color: "#333",
                          margin: 0,
                        }}
                      >
                        {item.question}
                      </h4>
                    </div>
                    <div
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "12px",
                        minHeight: "100px",
                        backgroundColor: "#fff",
                        color: "#000",
                        wordWrap: "break-word",
                        wordBreak: "break-word",
                        whiteSpace: "pre-wrap",
                        textAlign: "left",
                      }}
                    >
                      {item.answer.join(", ")}
                    </div>
                  </div>
                );
              })}
          </div>
        )}

        {/* Manual Upload popup */}
        {manualApplicatsConfirmPopup === true && (
          <section className="customModal">
            <div className="customModalDiv">
              <h1 className="modal-header">Error</h1>
              <div className="modal-body">
                <p>
                  We are currently facing a technical glitch. Please select to
                  upload resume manually.
                </p>
                <div className="modalActionBtns">
                  <Button
                    type="button"
                    className="cancelBtn"
                    style={{ marginRight: "20px" }}
                    onClick={() => {
                      setManualApplicatsConfirmPopup(false);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="button"
                    variant="contained"
                    className="saveBtn"
                    onClick={onManualuploadHandler}
                  >
                    Upload Manually
                  </Button>
                </div>
              </div>
            </div>
          </section>
        )}
        {duplicateApplicatsConfirmPopup === true && (
          <ApplicantsManualUploadPopup
            skipId={skipId}
            jobId={jobObj.jobId}
            isAssociatedApplicant={true}
            updateProfileWithNewResume={updateProfileWithNewResume}
            sourceId={sourceId}
            defaultFile={defaultFile}
            setDuplicateApplicatsConfirmPopup={(e) => {
              setDuplicateApplicatsConfirmPopup(e);
            }}
          />
        )}
        {twoDuplicateApplicatsConfirmPopup === true && (
          <DuplicateApplicantsManualUploadPopup
            skipId={skipId}
            skipName={skipName}
            setTwoDuplicateApplicatsConfirmPopup={() => {
              setTwoDuplicateApplicatsConfirmPopup(false);
              dispatch(_ser1.uploadResumeStartReducer(initalState));
              setSkipName(null);
            }}
          />
        )}
        <UpdateResumePopup
          open={isUpdateResumeOpen}
          onClose={handleCloseUpdateResume}
          resumes={resumeVersions}
          isLoading={isResumeVersionsLoading}
          selectedDocId={selectedResumeDocId}
          onSelect={setSelectedResumeDocId}
          onUpdate={handleUpdateResumeConfirm}
        />
      </>
    );
  },
);

const BulkComponentRenderData = ({ data, onReceivechildProps }) => {
  return (
    <>
      <div className="tabs">
        <TabContext value={"1"}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={""}
              aria-label="lab API tabs example"
              className="tabsvalue"
            >
              <Tab label="Bulk upload Results" value="1" />
            </TabList>
          </Box>
          <TabPanel value="1">
            {data && (
              <div>
                <div className="jobsdatacss">
                  <tr>
                    <td>Total Resumes</td>
                    <td>:</td>
                    <td>{data.totalResume}</td>
                  </tr>
                </div>
                <br />
                <Divider className="secline" />
                <p>
                  Your documents have been submitted for offline processing.
                  Once the process is complete, you will receive a confirmation
                  email and Please refresh the page.
                </p>
                {data.data &&
                  data.data.map((msg) => {
                    return (
                      <ul>
                        <li
                          style={{ textAlign: "left" }}
                          dangerouslySetInnerHTML={{ __html: msg }}
                        ></li>
                      </ul>
                    );
                  })}
              </div>
            )}
          </TabPanel>
        </TabContext>
      </div>
    </>
  );
};

const BulkUpdateStatus = ({
  data,
  jobId,
  jobCode,
  bulkUpdateStatusArray,
  onReceivechildProps,
}) => {
  const [bulkUpdateStatus, setBulkUpdateStatus] = useState("");

  const onChangeHandler = (value) => {
    setBulkUpdateStatus(value);
  };

  const selectedJobId = jobId;
  const dispatch = useDispatch();

  const handlebulkstatusUpdate = () => {
    if (bulkUpdateStatus !== "") {
      const statusId = getCandidateStatusId(bulkUpdateStatus, data);

      let newArray = bulkUpdateStatusArray.map((obj) => ({
        id: obj.asscoId,
        status: statusId,
        applicantCode: obj.applicantCode,
        applicantId: obj.applicantID.toString(),
        jobCode: jobCode,
      }));
      let updateData = { data: newArray };

      dispatch(_ser.updateCandidateStatusAsync(selectedJobId, updateData));
    } else {
      dispatch(updateSnackbar({ type: "error", message: "Change status" }));
    }
  };

  const updateCandidateCode = useSelector(
    (state) => state.UpdateCandidateStatus.data,
  );
  useEffect(() => {
    if (updateCandidateCode === 200) {
      dispatch(_ser.updateCandidateStatusStartReducer(initalState));
      onReceivechildProps(false, "close");
      dispatch(_ser.jobpostingsbyidAsync(selectedJobId));
    }
  }, [updateCandidateCode]);

  return (
    <>
      <div className="tabs">
        <TabContext value={"1"}>
          <Box>
            <TabList
              onChange={""}
              aria-label="lab API tabs example"
              className="tabsvalue w-100"
            >
              <Tab label="Details" value="1" />
            </TabList>
          </Box>
          <TabPanel value="1">
            {data && (
              <div className="bulkupdateStatusText">
                <tr>
                  <td>No of Applicants Selected</td>
                  <td>:</td>
                  <td>{bulkUpdateStatusArray.length}</td>
                </tr>

                <br />
                <tr>
                  <td>Update Status for Selected Applicants</td>
                  <td>
                    <div style={{ width: "100%" }}>
                      <FormControl fullWidth>
                        <Select
                          className="sourcedfrominput"
                          value={bulkUpdateStatus}
                          name="candidateStatus"
                          autoComplete="off"
                          onChange={(e) =>
                            onChangeHandler(e.target.value, "candidateStatus")
                          }
                          style={{
                            width: "200px",
                            height: "3rem",
                            paddingTop: "0.4rem",
                            borderRadius: "4px",
                          }}
                          displayEmpty
                          renderValue={(profileData) => {
                            if (bulkUpdateStatus === "") {
                              return (
                                <span
                                  color="gray"
                                  className="bulkstatusselectfeild"
                                >
                                  Select
                                </span>
                              );
                            } else {
                              return bulkUpdateStatus;
                            }
                          }}
                        >
                          {data.map((status) => (
                            <MenuItem
                              className="selectOptions"
                              key={status.id}
                              value={status.internal}
                            >
                              {status.internal}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </td>
                </tr>
              </div>
            )}
          </TabPanel>
        </TabContext>

        <div className="bulkUploadStatusUpdateButton">
          <Button
            className="updateButton"
            variant="contained"
            size="medium"
            type="submit"
            onClick={handlebulkstatusUpdate}
          >
            Update
          </Button>
        </div>
      </div>
    </>
  );
};

const ViewDocument = (props) => {
  const [docUrl, setDocUrl] = useState(null);

  useEffect(() => {
    if (props.previewType !== "") {
      setDocUrl(props.previewType);
    }
  }, [props]);

  return (
    <>
      <div
        style={{ textAlign: "center", width: "100%" }}
        className="associationDocViewer"
      >
        {docUrl !== null ? (
          <>
            <DocumentViewer
              url={docUrl}
              fileType={getFileExtension(docUrl)}
            />
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default JobpostingAssociatedApplicants;

const aiconfiguration = {
  recordperPage: 9,
  currentPage: 1,
  totalRecords: 0,
  limitData: 9,
  isSearchServer: false,
};

const findconfiguration = {
  recordperPage: 9,
  currentPage: 1,
  totalRecords: 0,
  limitData: 9,
  isSearchServer: true,
};

const configuration = {
  isSearchbar: true,
  isPaging: true,
  isDropdownActions: true,
  isCheckbox: true,
  isActions: true,
  recordperPage: 10,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: false,
  totalRecordsCount: 0,
  totalRecordsCountText: "",
  limitData: 10,
  isCheckAlignRight: true,
  isPaginationTop: false,
  isSearchServer: false,
  isPagingServer: false,
  isPageRange: true,
};

// for dynamic Table Action dropdownData
const mainDropdownList = [
  { type: "Associated Applicants", label: "Associated" },
  { type: "Pending Applicants", label: "Pending" },
  { type: "Rejected Applicants", label: "Rejected" },
];

// for dynamic Table row Action buttons

const QAObj = {
  title: "Questions and Answers",
  description: "",
  bgImage: "",
};

const bulkResponseObj = {
  title: "Bulk Upload",
  description: "",
  bgImage: ``,
};
const UpdateStatusObj = {
  title: "Update Status",
  description: "",
  bgImage: "",
};
const docViewObj = {
  title: "Document view",
  description: "",
  bgImage: "",
};

const initialData = {
  noteType: "",
  noteText: "",
};

const MailOBJ = {
  title: "Send E-mail",
  description: "",
  bgImage: `${process.env.PUBLIC_URL}/assests/img/emailbackground.svg`,
};
